import { throwError } from "@/lib/throwError";
import { get, post, put } from "@/services/axiosUitils";
import {
  SchemaPayload,
  TenantSchema,
  TenantSchemaList,
} from "@/utils/types/schemas";

const basePath = "/formily/schemas";

class SchemaService {
  getAllSchemas = async ({
    page,
    pageSize,
    search,
  }: {
    page: number;
    pageSize: number;
    search: string;
  }): Promise<TenantSchemaList> => {
    return await get<TenantSchemaList>(`${basePath}/`, {
      params: {
        page,
        page_size: pageSize,
        search,
      },
    });
  };

  getSchemaByName = async (schemaName: string): Promise<TenantSchema> => {
    if (!schemaName) {
      throwError("Schema name is required", "SchemaService");
    }
    return await get<TenantSchema>(`${basePath}/${schemaName}/`);
  };

  createSchema = async ({
    schemaName,
    payload,
  }: SchemaPayload): Promise<any> => {
    if (!schemaName || !payload) {
      throwError("Schema name and payload are required", "SchemaService");
    }
    return await post(`${basePath}/${schemaName}/`, payload);
  };

  updateSchema = async ({
    schemaName,
    payload,
  }: SchemaPayload): Promise<any> => {
    if (!schemaName || !payload) {
      throwError("Schema name and payload are required", "SchemaService");
    }
    return await put(`${basePath}/${schemaName}/`, payload);
  };

  getDropDownData = async (schemaName: string): Promise<any> => {
    if (!schemaName) {
      throwError("Schema name is required", "SchemaService");
    }
    return await get(`${basePath}/${schemaName}/drop_down_data/`);
  };

  getColumnGridData = async (schemaName: string): Promise<any> => {
    if (!schemaName) {
      throwError("Schema name is required", "SchemaService");
    }
    return await get(`${basePath}/${schemaName}/column-grid/`);
  };
}

const instance = new SchemaService();
export default instance;
